#import "./email-sequence-fragment.graphql"
fragment EmailAutomationStatusesFragment on EmailAutomationStatus {
    id
    sender {
        id
        name
        sendableEmailAddresses {
            id
            isEnabledForSending
        }
    }
    unsentMessageCount
    isPaused
    canStart
    canCancel
    status
    companyName {
        value
        required
    }
    firstName {
        value
        required
    }
    lastName {
        value
        required
    }
    lead {
        id
        assignee {
            id
            name
        }
        contacts {
            primaryEdge {
                node {
                    id
                    name
                    emailAddresses {
                        primary {
                            name
                        }
                    }
                }
            }
        }
    }
    emailAutomation {
        id
        entersStage {
            id
            name
        }
        exitsStage {
            id
            name
        }
        sendUntilClose
        delay {
            unit
            timespan
        }
        emailList {
            id
            name
        }
    }
    emailSequence {
        ...EmailSequenceFragment
    }
}
